/**
 * Claves de módulo/acción del catálogo de permisos, sincronizadas a mano con
 * PermisoConstants.java. Si el backend agrega/quita un módulo o acción, actualizar aquí también.
 */
export const MODULO = {
  USUARIOS: 'USUARIOS',
  PERMISOS: 'PERMISOS',
  GRUPOS: 'GRUPOS',
  PERFILES_SEGURIDAD: 'PERFILES_SEGURIDAD',
  SUCURSALES: 'SUCURSALES',
  KIOSKOS: 'KIOSKOS',
  MULTIMEDIA: 'MULTIMEDIA',
  TURNOS: 'TURNOS',
  TRAMITES: 'TRAMITES',
  CITAS: 'CITAS',
  SALAS: 'SALAS',
  REPORTES: 'REPORTES',
  CONFIG_APLICACION: 'CONFIG_APLICACION',
  AVISOS: 'AVISOS',
  TELEFONOS_BLOQUEADOS: 'TELEFONOS_BLOQUEADOS',
  IPS_BLOQUEADAS: 'IPS_BLOQUEADAS',
  BITACORA_TURNO: 'BITACORA_TURNO',
  REGISTRO_CHATBOT: 'REGISTRO_CHATBOT',
  LIMITES_CANAL: 'LIMITES_CANAL',
  PUESTOS: 'PUESTOS',
  ROLES: 'ROLES',
} as const;

export const ACCION = {
  CONSULTAR: 'CONSULTAR',
  CREAR: 'CREAR',
  EDITAR: 'EDITAR',
  DESACTIVAR: 'DESACTIVAR',
  RESTABLECER_PASSWORD: 'RESTABLECER_PASSWORD',
  ELIMINAR: 'ELIMINAR',
  EXPORTAR: 'EXPORTAR',
  EMITIR: 'EMITIR',
  CANCELAR: 'CANCELAR',
} as const;

export type ModuloClave = typeof MODULO[keyof typeof MODULO];
export type AccionClave = typeof ACCION[keyof typeof ACCION];
